var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewbulkorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58054 4.79883H0V8.20151H4.58054V4.79883ZM3.70805 7.35084H0.872483V5.67131H3.70805V7.35084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6141 4.79883H6.10742V8.20151H14.6141V4.79883ZM13.7416 7.35084H6.97991V5.67131H13.7416V7.35084Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58054 0H0V3.40268H4.58054V0ZM3.70805 2.55201H0.872483V0.872483H3.70805V2.55201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6141 0H6.10742V3.40268H14.6141V0ZM13.7416 2.55201H6.97991V0.872483H13.7416V2.55201Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58054 9.59717H0V12.9999H4.58054V9.59717ZM3.70805 12.1492H0.872483V10.4697H3.70805V12.1492Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6141 9.59717H6.10742V12.9999H14.6141V9.59717ZM13.7416 12.1492H6.97991V10.4697H13.7416V12.1492Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewbulkorders);
export default __webpack_public_path__ + "static/media/view bulk orders.6a8e1fd1423c85c5d9000337ffcd3963.svg";
export { ForwardRef as ReactComponent };